
















































import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import { IGallery, IPhotoFormat } from "@/@types/gallsery/gallery";
import { ICoast } from "@/@types/_shared/coast";

@Component({ components: { ChangeDeliteButtons, BSwitch, ContextMenu } })
export default class GalleryFolderList extends Vue {
  @Prop({ type: Array, default: () => [] }) photos!: Array<string>;
  @Prop({ type: Array, default: () => [] }) formatList!: Array<IPhotoFormat>;
  @Prop({ type: String, default: "" }) photoFolder!: string;
  @Prop({ type: String, default: "" }) activeCategory!: string;
  @Inject("folder") readonly folder!: string;

  getPhotosColumn: Array<Array<string>> = [];
  constxtID = "";

  $refs!: {
    imgContainer: Array<HTMLElement>;
    img: Array<HTMLElement>;
    menu: ContextMenu;
  };

  @Watch("photos")
  photosColumn(): void {
    const arr = this.photos.slice();
    let size = Math.ceil(arr.length / 6);
    let subarray = [];
    for (let i = 0; i < Math.ceil(arr.length / size); i++) {
      subarray[i] = arr.slice(i * size, i * size + size);
    }
    this.getPhotosColumn = subarray;
  }

  distributionElements(): void {
    this.photosColumn();
    let counter = 0;
    while (!this.$refs.imgContainer) {
      if (counter > 100) return;
      counter++;
    }
    const cols = this.$refs.imgContainer;
    const heights: Array<number> = [];
    for (let i = 0; i < cols.length; i++) {
      heights.push(cols[i].children[0].clientHeight);
    }

    let size = 2;
    let subarray = [];
    for (let i = 0; i < Math.ceil(heights.length / size); i++) {
      subarray[i] = heights.slice(i * size, i * size + size);
    }

    const max = Math.max(heights.length);
    const min = Math.min(heights.length);

    for (let i = 0; i < heights.length; i++) {
      if (heights[i] == max) {
        const el = this.getPhotosColumn[i].pop();
        if (!el) return;
        for (let j = 0; j < heights.length; j++) {
          if (heights[i] == min) {
            this.getPhotosColumn[j].push(el);
          }
        }
      }
    }
  }

  getFormatCoast(id: string): Array<ICoast> {
    const format = this.formatList.find((format) => format._id === id);
    return format ? format.coast : [];
  }

  guickChange(folder: IGallery): void {
    folder.show = !folder.show;
    this.$emit("updateFolder", folder);
  }

  guickChangeWatermark(folder: IGallery): void {
    folder.watermark = !folder.watermark;
    this.$emit("updateFolder", folder);
  }

  changeElement(id: string): void {
    const uri = pics.gallery;
    deleteImages(id, this.activeCategory, uri)
      .then(() => {
        console.log("delete");
        this.$emit("deletePhoto", id);
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  mounted(): void {
    this.$nextTick(() => {
      this.distributionElements();
    });
  }
}
